import BaseToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'

const ToggleButtonGroup = BaseToggleButtonGroup

export default ToggleButtonGroup
